@import "../../../../../../styles/variables";
@import "../../../../../../styles/mixins/svs-design-system";
@import "../../../../../../styles/mixins/_label-list";
@import "../../../../../../styles/mixins/_search-skeleton";

@media screen and (max-width: 780px) {
  .community_item_container {
    min-height: 83px !important;
  }
}

.document__container {
  margin: 0 0 20px;
  a {
    text-decoration: none;
    &:hover {
      .result-card__title-link {
        text-decoration: underline;
      }
    }
  }

  h3 {
    font-size: 18px;
  }
  @media (max-width: $uiaas-tablet) {
    min-height: 300px;
    @include shadow-small;
    padding: 20px;
    margin: 0;
    margin-bottom: 20px;

    &:hover {
      @include shadow-medium;
    }
    .result-card__title {
      word-break: break-word;
    }
  }
  @media (min-width: $uiaas-tablet) {
    display: flex;
  }
  div.document__content {
    width: 100%;
  }
}

.document__divider {
  margin-top: 24px;
  margin-bottom: 14px;
}

.document__title {
  color: $uiass-link-color;
  line-height: 30px;
  font-weight: 400;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.document__description {
  display: -webkit-box;
  font-size: 14px;
  line-height: 20px;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.document__download-container {
  margin: 8px 0 0 -8px;
}

.document__download {
  display: flex;
  align-items: center;
  &-space {
    margin-right: 6px;
  }
  &-title {
    max-width: 70%;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break: break-all;
  }
}

.document__label-panel {
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  color: $svs-se-dark-grey;
  margin-top: 4px;
  @media (min-width: $uiaas-tablet) {
    line-height: 20px;
    font-size: 14px;
  }
}

.document__category {
  color: var(--qds-theme-signature-color-default, #008a16);

  &-accessibility {
    color: #333;
  }
}

.community-widget-header {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.replies-tag {
  margin-top: 8px;
}

.result-card__thumbnail-section {
  min-height: 140px;
  margin-right: 20px;
}
.dashboard-view-main-content {
  min-height: 100vh;
}

.search-skeleton-container {
  background-color: white;
  margin-bottom: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.search-skeleton__block {
  flex-direction: row;
  flex: 1 0 49%;
  width: 100%;
  margin-top: 16px;
}

.search-skeleton__section {
  margin-bottom: 16px;
  display: flex;
  flex: 1;
  align-items: center;
}

.skeleton__image {
  margin-right: 20px;
}

@include search-skeleton;

@include label-list;
